export const CourseTypesEnum = Object.freeze({
  OFFLINE: 'offline',
  ONLINE: 'online',
});